import Vue from 'vue'

import validationRules from './validationRules';
Vue.mixin(validationRules);

import helpers from './helpers';
Vue.mixin(helpers);